import * as Yup from 'yup'
import { useFormik } from 'formik'
import clsx from 'clsx'
import { useParams } from 'react-router-dom'
import { supportQuery } from '../../../../api'
import { swlAlert } from '../../../../../component'
import Swal from 'sweetalert2'
import { FullPageLoader } from '../../../../../component/helper'
// import { PanDetails } from './PanDetails'
/**
 * Yup validation schema for the support form fields.
 */
const editUserSchema = Yup.object().shape({
    subject: Yup.string().trim().required('Subject is required'),
    message: Yup.string().trim().required('Message is required'),

})

/**
 * SupportForm component for raising a support query, including form state, validation, and submission.
 */
export const SupportForm = ({ data, isUserLoading }) => {
    const { user_id } = useParams()
    const project_key = localStorage.getItem('pkey');
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            user_code: user_id,
            subject: '',
            message: '',
            project_key: project_key
        },
        validationSchema: editUserSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {
                setSubmitting(true);

                const confirmResult = await Swal.fire({
                    title: 'Are you sure?',
                    text: 'Are you sure you want to add?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    reverseButtons: true,
                    customClass: {
                        confirmButton: 'btn btn-danger',
                        cancelButton: 'btn btn-secondary'
                    }
                });
                if (confirmResult.isConfirmed) {
                    const response = await supportQuery(values)
                    swlAlert(response);
                    if (Number(response.code) === 1) {
                        resetForm();
                    }
                }
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        }
    })



    return (<>
        {formik.isSubmitting && <FullPageLoader />}
        <div className="container mt-5">
            <form id="kt_form" className="form fv-plugins-bootstrap5 fv-plugins-framework"
                onSubmit={formik.handleSubmit} noValidate>
                <div style={{ border: '1px solid #E6E6E6' }} className="card">
                    <div className="card-header" style={{ minHeight: '39px' }}>
                        <div className="card-title fw-semibold fs-5 py-1"> Raise a Query
                        </div>
                    </div>
                    <div className="card-body pt-2 pb-2 border-top">
                        <div className='row'>
                            <div className="col-lg-12 col-xl-12">
                                <div className='row'>
                                    <label className="col-lg-4 col-form-label required fw-semibold fs-6">Subject</label>
                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <input
                                            placeholder="Enter Subject"
                                            {...formik.getFieldProps('subject')}
                                            type='text'
                                            onChange={formik.handleChange}
                                            name='subject'
                                            className={clsx(
                                                'form-control form-control-lg ',
                                                { 'is-invalid': formik.touched.subject && formik.errors.subject },
                                                { 'is-valid': formik.touched.subject && !formik.errors.subject, }
                                            )}
                                            autoComplete='off'
                                            disabled={formik.isSubmitting || isUserLoading}
                                        />
                                        {formik.touched.subject && formik.errors.subject ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.subject}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7"></div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-12 mt-2">
                                <div className='row'>
                                    <label className="col-lg-4 col-form-label required fw-semibold fs-6">Message</label>
                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <textarea
                                            {...formik.getFieldProps('message')}
                                            onChange={formik.handleChange}
                                            name="message"
                                            className="form-control form-control-lg form-control-solid  "
                                            placeholder="Type Message"
                                            style={{ height: "200px", width: "100%" }}>
                                        </textarea>

                                        {formik.touched.message && formik.errors.message ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.message}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7"></div>}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='card-footer py-2'>
                        <div className="d-flex justify-content-end">

                            <button type="onclick" id="kt_ecommerce_add_Company_submit" className="btn btn-primary"
                                disabled={formik.isSubmitting || !formik.isValid}>
                                <span className="indicator-label">{formik?.values?.id ? "Update " : "Save "}</span>
                                {(formik.isSubmitting) && <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>}
                            </button>


                        </div>
                    </div>
                </div>

            </form >
        </div>

    </>
    )
}